var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 33,
    viewBox: "0 0 19 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36353 28.05H11.1362V33H6.36353V28.05ZM9.5453 0C18.0565 0.363 21.7633 9.273 16.7043 15.9555C15.3838 17.6055 13.2521 18.6945 12.2021 20.0805C11.1362 21.45 11.1362 23.1 11.1362 24.75H6.36353C6.36353 21.9945 6.36353 19.668 7.42943 18.018C8.47941 16.368 10.6112 15.3945 11.9316 14.3055C15.7816 10.6095 14.827 5.379 9.5453 4.95C8.27952 4.95 7.06557 5.47152 6.17053 6.39982C5.27548 7.32813 4.77265 8.58718 4.77265 9.9H0C0 7.27436 1.00566 4.75625 2.79575 2.89964C4.58585 1.04303 7.01373 0 9.5453 0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.dc2c469fd137f6623922cdf73b50deb3.svg";
export { ForwardRef as ReactComponent };